/*
 * @创建人: 但志强s
 * @修改人: 但志强
 * @描述: 高级查询
 * @创建时间: 2019-07-25 10:46:59
 * @修改时间: 2019-08-05 17:21:21
 * 
 */
import { Component, OnInit, Output, EventEmitter, ViewChild, Input, OnChanges } from '@angular/core';
import { SwModalframeComponent } from '../../sw-modal-frame/sw-modal-frame.component';

/**
 * 高级查询  sw-deep-select
 */
@Component({
  selector: 'sw-deep-select',
  templateUrl: './sw-deep-select.component.html',
  styleUrls: ['./sw-deep-select.component.css']
})
export class SwDeepSelectComponent implements OnInit {

  /**
  * @ignore
  */
  constructor() { }

  /**
   * 组合查询基础数据
   * 
   *  concatData:any=[
   * 
   *      {id:1,text:'文本',code:'text',type:'input' },
   * 
   *      {id:2,text:'下拉框',code:'select',type:'select',data:this.dicService.getDictionaryValueOrName("CRP_MATERIAL_OPTION")},
   * 
   *      {id:3,text:'多选框',code:'multi',type:'select-multi',data:this.dicService.getDictionaryValueOrName("CRP_MATERIAL_OPTION")},
   * 
   *      {id:4,text:'日期单选',code:'date',type:'date',format:"YYYY-MM-DD"},
   * 
   *      {id:5,text:'日期范围选',code:'datepicker',type:'daterange',format:"YYYY-MM-DD",range:true}]
   * 
   *  参数说明 id:主键 不可重复 text :显示的中文 code：查询的字段 ，type：类型只支持以上五种 ，data:显示的数据 用于下拉数据，format：用于日期格式化
   */
  @Input() concatData: any = []

  /**
   * 点击查询事件抛出 eg:[{code：'' ,value:''}]
   */
  @Output() onDeepSelect = new EventEmitter;

  /**
  * @ignore
  */
  @ViewChild('deepModal') modal: SwModalframeComponent;

  /**
  * @ignore
  */
  ngOnInit() {
  }
  /**
   * 弹出模态框
   * @ignore
   * @memberof SwDeepSelectComponent
   */
  clickbtn(e) {
    this.modal.toggle();
  }
  /**
   * 处理查询事件，发射回调
   * @memberof SwDeepSelectComponent
   * @ignore
   */
  dealSelect() {
    let selectedTags = {}
    this.concatData.map(item => {
      selectedTags[item.code] = item.value;
    })
    this.onDeepSelect.emit(selectedTags);
  }
}
